import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "./cn";

type Tone = "neutral" | "accent" | "success" | "warn" | "danger" | "info";

const TONE: Record<Tone, string> = {
  neutral: "border-line-soft/70 bg-surface-2/70 text-fg-muted",
  accent: "border-[hsl(var(--accent)/0.5)] bg-[hsl(var(--accent)/0.12)] text-accent-300",
  success: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300",
  warn: "border-amber-500/40 bg-amber-500/10 text-amber-200",
  danger: "border-rose-500/50 bg-rose-500/10 text-rose-200",
  info: "border-sky-500/40 bg-sky-500/10 text-sky-200",
};

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  icon?: ReactNode;
  monospace?: boolean;
}

export function Pill({
  tone = "neutral",
  icon,
  monospace,
  className,
  children,
  ...rest
}: PillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs",
        monospace && "font-mono uppercase tracking-wider text-[11px]",
        TONE[tone],
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </span>
  );
}
